import React, { useState, useEffect } from 'react';
import OrderModal from './OrderModal';
import { useApp } from '../../context/AppContext';
import api from '../../utils/api';

const OrderNotificationHandler = () => {
  const { actions } = useApp();
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Listen for order notification view events
    const handleOrderNotificationView = async (event) => {
      const { orderId, orderDocId, notification } = event.detail;
      
      console.log('🎯 Order notification view event received:', { orderId, orderDocId });
      
      try {
        setLoading(true);
        
        // Fetch order details from API
        const orderIdToFetch = orderId || orderDocId;
        const response = await api.get(`/orders/${orderIdToFetch}`);
        
        if (response.data.success) {
          setSelectedOrder(response.data.order);
          setOrderModalOpen(true);
          
          actions.showSnackbar(
            `Opening order details for #${orderId}`,
            'info'
          );
        } else {
          actions.showSnackbar(
            `Order #${orderId} not found`,
            'error'
          );
        }
      } catch (error) {
        console.error('Error fetching order details:', error);
        actions.showSnackbar(
          `Failed to load order details for #${orderId}`,
          'error'
        );
      } finally {
        setLoading(false);
      }
    };

    // Add event listener
    window.addEventListener('orderNotificationView', handleOrderNotificationView);

    // Cleanup
    return () => {
      window.removeEventListener('orderNotificationView', handleOrderNotificationView);
    };
  }, [actions]);

  const handleCloseOrderModal = () => {
    setOrderModalOpen(false);
    setSelectedOrder(null);
  };

  return (
    <>
      {/* Order Modal */}
      <OrderModal 
        open={orderModalOpen}
        onClose={handleCloseOrderModal}
        order={selectedOrder}
      />
      
      {/* Loading overlay could be added here if needed */}
      {loading && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'rgba(0,0,0,0.1)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          zIndex: 9999 
        }}>
          <div style={{ 
            background: 'white', 
            padding: '20px', 
            borderRadius: '8px', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px' 
          }}>
            <div style={{ 
              width: '20px', 
              height: '20px', 
              border: '2px solid #f3f3f3', 
              borderTop: '2px solid #3498db', 
              borderRadius: '50%', 
              animation: 'spin 1s linear infinite' 
            }}></div>
            <span>Loading order details...</span>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderNotificationHandler; 